import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchPilotTrackerMovements } from "../../apis/pilotTracker";

import type { RootState } from "../reducers/reducer";

export const fetchPilotTrackerData = createAsyncThunk(
  "pilotTracker/fetchPilotTracker",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchPilotTrackerMovements();
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
